.container {
    width: 250px;
}

.scroll-container {
    justify-content: safe center;
}

.loading-container {
    width: 100%;
    height: 322px; /* matches height of calendars to prevent layout shift moving from loading to loaded */
}
